export default {
  // 模式
  "common.mode.auto": "အလိုအလျောက် မွေးထုတ်စွမ်းအင် အသုံးပြုမုဒ်",
  "common.mode.economy": "စီးပွားရေး မုဒ်",
  "common.mode.exigency": "အရေးပေါ် အခြေအနေ မုဒ်",

  // 设备
  "common.grid": "လျှပ်စစ် ကွန်ရက်",
  "common.evChargers": "လျှပ်စစ်ကား ငါးပေါင်း ကားအားပေးစက်",
  "common.evCharger": "လျှပ်စစ်ကား ငါးပေါင်း ကားအားပေးစက်",
  "common.pv": "ဖိုတိုဗို့တေက် စွမ်းအင် (PV)",
  "common.inverter": "အင်ဗာတာ (လျှပ်စစ် ပြောင်းပေးစက်)",
  "common.pcs": "အင်ဗာတာ + ဘက်ထရီ",
  "common.terminal": "အဆုံးမှတ် ကိရိယာ",
  "common.airc": "အေးပေးစက် (အက်ယား ကွန်ဒီရှင်နာတာ)",
  "common.engine": "အင်ဂျင်",
  "common.battery": "ဘက်ထရီ",
  "common.metter": "လျှပ်စစ် တိုင်းတာမီတာ",
  "common.other": "အခြား",
  "common.power": "စွမ်းအင် (ပါဝါ)",
  "common.powerTotal": "စုစုပေါင်း စွမ်းအင်",
  "common.voltage": "ဗို့တေ့ (လျှပ်စစ် ဖိအား)",
  "common.electricity": "လျှပ်စစ် စွမ်းအင်",
  "common.current": "လျှပ်စစ် စီးကြောင်း (ကျွန်း)",
  "common.homeUsage": "အိမ် စုစုပေါင်း ဝန်",
  "common.battery.power": "ဘက်ထရီ စွမ်းအင်",

  // 数据
  "common.noDataAvailable": "ဒေတာ ယခုအချိန်တွင် ရရှိနေပါဘူး~",
  "common.tips": "အကြံပြုချက်",
  "common.reset": "ပြန်လည် ထားမည် (ရှင်းလင်းမည်)",
  "common.currencyUnit": "¥ (ယुआန်)",
  "common.submiting": "ပို့နေပါသည်... ကျေးဇူးပြု၍ စောင့်ပါ...",
  "common.close": "ပိတ်ပါ",
  "common.from": "မှ",
  "common.useIn": "အတွက်",
  "common.energyPercent": "စွမ်းအင် စီးကြောင်း ရာခိုင်နှုန်း",
  "common.dataFlow": "ဒေတာ စီးကြောင်း",
  "common.getDataIng": "ဒေတာ ရယူနေပါသည်... ကျေးဇူးပြု၍ စောင့်ပါ...",
  "common.pageLoading": "စာမျက်နှာ အကြောင်းအရာ ကိုယ်ယူနေပါသည်... ကျေးဇူးပြု၍ စောင့်ပါ...",
  "common.reseting": "စာမျက်နှာ အကြောင်းအရာ ပြန်လည် ထားနေပါသည်... ကျေးဇူးပြု၍ စောင့်ပါ...",
  "common.save": "သိမ်းဆည်းပါ",
  "common.onlyNumberTips": "ကိန်းဂဏန်းသာ ရိုက်ထည့်နိုင်ပါသည်",
  "common.offline": "အော့ဖ်လိုင်း (အွန်းလိုင်း မရှိ)",
  "common.online": "အွန်းလိုင်း (အွန်းလိုင်း ရှိ)",
  "common.fault": "အမှား (ပြဿနာ)",
  "common.charge": "အားပေး (ဘက်ထရီ ငါးပေါင်း)",
  "common.discharge": "အားထုတ် (ဘက်ထရီ စွမ်းအင် ထုတ်)",
  "common.buy": "ဝယ်",
  "common.sell": "ရောင်း",
  "common.loadingInfo": "ကိုယ်ယူနေပါသည်... ကျေးဇူးပြု၍ စောင့်ပါ...",

  // 通用功能
  "common.moreFeatures": "ပိုမို ကျွမ်းကျင်မှုများ",
  "common.confirm": "အတည်ပြုပါ",
  "common.saveing": "သိမ်းဆည်းနေပါသည်... ကျေးဇူးပြု၍ စောင့်ပါ...",
  "common.searchPlacholder": "ရှာဖွေရန် ဝေါဟာရ ရိုက်ထည့်ပါ",
  "common.iSee": "ငါ နားလည်ပြီ",
  "common.pageErrorTips1": "အိုး, စာမျက်နှာတွင် အမှား ဖြစ်ပွားပါသည်~",
  "common.pageErrorTips2": "စာမျက်နှာကို ပြန်လည် ကိုယ်ယူရန် သို့မဟုတ် ပံ့ပိုးပေးရေးနှင့် ဆက်သွယ်ပါ~",
  "common.refresh": "ပြန်လည် ကိုယ်ယူပါ",
  "common.backToHome": "မူလ စာမျက်နှာသို့ ပြန်သွားပါ",
  "common.checkTips": "စစ်ဆေးနေပါသည်... ကျေးဇူးပြု၍ စောင့်ပါ...",
  "common.back": "ပြန်သွားပါ",
  "common.cancel": "ဖျက်ပါ (ပယ်ဖျက်ပါ)",
  "common.optional": "ရွေးချယ်စရာ (မဖြစ်မနေမဟုတ်)",
  "common.required": "ဖြစ်မနေ လိုအပ်သည်",
  "common.status": "အခြေအနေ",
  "common.statusNoDelete": "ဖျက်ထားပါဘူး",
  "common.statusDelete": "ဖျက်ထားပါသည်",
  "common.submit": "ပို့ပါ",
  "common.disable": "မသုံးပါ (ပိတ်ထားပါ)",
  "common.enable": "သုံးပါ (ဖွင့်ထားပါ)",
  "common.year": "နှစ်",
  "common.month": "လ",
  "common.day": "နေ့",
  "common.version": "ဗားရှင်း:",
  "common.backHome": " မူလ စာမျက်နှာသို့ ပြန်သွားပါ",
  "common.backHomeSorry": "ကျေးဇူးပြု၍ တောင်းပန်ပါတယ်, စာမျက်နှာသည် မအမှန်ပါဘူး သွားလိုက်ပါတယ်",
  "common.requestTips1": "ဒေတာ ကိုယ်ယူအားဖြင့် လုပ်ဆောင်နေပါသည်, ပြန်လည် ပို့မနေပါ",
  "common.requestTips2": "စနစ် အသိပေးချက်များ",
  "common.requestTips3": "အကောင့် ဝင်ခွင့် ကာလကုန်ဆုံးပါသည်, ကျေးဇူးပြု၍ ပြန်လည် ဝင်ပါ",
  "common.requestTips4": "ပြန်လည် ဝင်ပါ",
  "common.requestTips5": "မမှန်ကန်သော အကောင့် ဝင်ခွင့် သို့မဟုတ် ကာလကုန်ဆုံးပါသည်, ကျေးဇူးပြု၍ ပြန်လည် ဝင်ပါ.",
  "common.requestTips6": "ဆာဗာအမှားဖြစ်နေပါတယ်၊ နောက်ပိုင်းတွင်ထပ်ကြိုးစားပါ။",
  "common.requestTips7": "စနစ် အင်တာဖေ့စ် တောင်းဆိုမှု ကာလကုန်ဆုံးပါသည်",
  "common.requestTips8": "စနစ် အင်တာဖေ့စ်",
  "common.requestTips9": "အမှား",
  "common.iknow": "ငါ နားလည်ပြီ",
  "common.logoutSuccess": "အကောင့် ထွက်ခြင်း အောင်မြင်ပါသည်",
  
  // 了解更多组件
  "common.knowMore.title": "ပိုမို အချက်အလက် ရရှိရန်, Beineng နှင့် ဆက်သွယ်ပါ",
  "common.knowMore.email": "ဆက်သွယ်ရန် အီးမေးလ်",
  "common.knowMore.phone": "ဆက်သွယ်ရန် ဖုန်းနံပါတ်",
  "common.knowMore.wechat": "ဆက်သွယ်ရန် WeChat",
  "common.knowMore.website": "တရားဝင် ဝဘ်ဆိုက် လိပ်စာ",
  "common.knowMore.address": "ဆက်သွယ်ရန် လိပ်စာ",
  "common.knowMore.addressDetail": "ကွမ်းဒေါင်းပြည်နယ် တောင်ကွမ်းမြို့ ဟွမ်းကျန်းမြို့နယ် ဟွမ်းကျင်းကင်းကျေးရွာ၊ ကျင်းဟီးလမ်း 8, အဆောက်အအုံ 5, အခန်း 1205၊ 1301",
  
  // 本地连接组件
  "common.localConnection": "ဒေသဆိုင် ဆက်သွယ်မှု",
  "common.operateInApp": "အက်ပ್ಲီကေးရှင်းအတွင်း လုပ်ဆောင်ပါ!",
  
  "common.enbleStaus": "ဖွင့်ထားသည့် အခြေအနေ",
  "common.battery.status": "အားပေးလည်း မရှိ၊ အားထုတလည်း မရှိ",

  // 账户相关
  "account.forgetThePassword": "ပാസ်ဝေါဒ် မေ့နေပါပြီ",
  "account.logInDirectly": "တိုက်ရိုက် ဝင်ပါ",
  "account.tips1": "စာမျက်နှာသို့ ပြန်ညွှန်းနေပါသည်... ကျေးဇူးပြု၍ စောင့်ပါ...",
  "account.tips2": "ပထမဦးစွာ အသုံးပြုမှု စည်းမျဉ်းများကို ဖတ်ပြီး လက်ခံပါ!",
  "account.autoLogin": "အလိုအလျောက် ဝင်ခွင့်",
  "account.userLogin": "အသုံးပြုသူ ဝင်ခွင့်",
  "account.registerTips": "အကောင့်မရှိဘူးလား? မှတ်ပုံတင်ရန် ဤနေရာတွင် ကလစ်နှိပ်ပါ",
  "account.userEmail": "အသုံးပြုသူ အမည် / အီးမေးလ်",
  "account.userEmailTips": "အသုံးပြုသူ အမည် သို့မဟုတ် အီးမေးလ် ရိုက်ထည့်ပါ",
  "account.password": "ပാസ်ဝေါဒ်",
  "account.passwordTips": "ပാസ်ဝေါဒ် ရိုက်ထည့်ပါ",
  "account.submit": "ပို့ပါ",
  "account.submitTips": "ပို့နေပါသည်... ကျေးဇူးပြု၍ စောင့်ပါ...",
  "account.otherLoginTips": "သို့မဟုတ် အခြား ဝင်ခွင့် နည်းလမ်းကို ရွေးချယ်ပါ",
  "account.userRegistration": "အသုံးပြုသူ မှတ်ပုံတင်ခြင်း",
  "account.userName": "အသုံးပြုသူ အမည်",
  "account.userNameTips": "အသုံးပြုသူ အမည် ရိုက်ထည့်ပါ",
  "account.emailTips1": "အီးမေးလ် လိပ်စာ ရိုက်ထည့်ပါ",
  "account.emailTips2": "မမှန်ကန်သော အီးမေးလ် ပုံစံ",
  "account.phone": "ဖုန်းနံပါတ်",
  "account.phoneTips1": "ဖုန်းနံပါတ် ရိုက်ထည့်ပါ",
  "account.phoneTips2": "မမှန်ကန်သော ဖုန်းနံပါတ်",
  "account.phoneTips3": "ဖုန်းနံပါတ် ရိုက်ထည့်ပါ",
  "account.passwordTips1": "ပാസ်ဝေါဒ် ရိုက်ထည့်ပါ (6-30 ဝေါဟာရ)",
  "account.passwordTips2": "မမှန်ကန်သော ပാസ်ဝေါဒ် ပုံစံ: ပാസ်ဝေါဒ်သည် အင်္ဂလိပ် အက္ခရာများ၊ ကိန်းဂဏန်းများ၊ အောက်ခြေလိုင်း (_)၊横线 (-) နှင့် အမှတ် (.) ပါဝင်ရမည်၊ ရှည်လျားမှု 6-12 ဝေါဟာရ",
  "account.passwordTips3": "ရိုက်ထည့်ထားသည့် ပാസ်ဝေါဒ်နှစ်ခု မတူညီပါဘူး, ကျေးဇူးပြု၍ စစ်ဆေးပြီး ပြန်လည် ရိုက်ထည့်ပါ!",
  "account.passwordTips4": "ပാസ်ဝေါဒ် ရိုက်ထည့်ပါ: ပാസ်ဝေါဒ်သည် အင်္ဂလိပ် အက္ခရာများ၊ ကိန်းဂဏန်းများ၊ အောက်ခြေလိုင်း (_)၊横线 (-) နှင့် အမှတ် (.) ပါဝင်ရမည်",
  "account.passwordTips5": "ပാസ်ဝေါဒ် အတည်ပြုခြင်း",
  "account.passwordTips6": "ပാസ်ဝေါဒ် အတည်ပြုရန် ရိုက်ထည့်ပါ",
  "account.passwordTips7": "ရိုက်ထည့်ထားသည့် ပാസ်ဝေါဒ်နှစ်ခု မတူညီပါဘူး, ကျေးဇူးပြု၍ စစ်ဆေးပြီး ပြန်လည် ရိုက်ထည့်ပါ!",
  "account.passwordTips8": "ပാസ်ဝေါဒ် အတည်ပြုရန် ရိုက်ထည့်ပါ",
  "account.passwordTips9": "ဂုဏ်ယူပါတယ်, မှတ်ပုံတင်ခြင်း အောင်မြင်ပါသည်!",
  "account.passwordTips10": "သင့် အသုံးပြုသူ အမည် ကတော့:",
  "account.emailIs": "အီးမေးလ် ကတော့:",
  "account.goToLoginPage": "s စက္ကန့်အတွင်း အလိုအလျောက် ဝင်ခွင့် စာမျက်နှာသို့ ပြန်ညွှန်းပါသည်",
  "account.goLogin": "ဝင်ပါ",
  "account.goRegister": "မှတ်ပုံတင်ပါ",
  "account.loginSuccess": "ဝင်ခြင်း အောင်မြင်ပါသည်",
  "account.email": "အီးမေးလ်",
  "account.sologn": "ငါတို့ သင့်အတွက် ဂရုတစိုက် စိတ်ဝင်စားစွာ ပြုလုပ်ထားသော စွမ်းအင် ပလန် တစ်ခုကို ဖန်တီးပါတယ်",
  "account.pleaseAgree": "ငါ ဖတ်ပြီး လက်ခံပါသည်",
  "userAgreement.privacyPolicy": "ကိုယ်ရေးကိုယ်တာ ဥပဒေများ",

  // 验证码相关
  "account.code": "အတည်ပြုကုဒ်",
  "account.codeTips": "အတည်ပြုကုဒ် ရိုက်ထည့်ပါ",
  "account.codeTips2": "မမှန်ကန်သောအတည်ပြုကုဒ်",

    "account.inviteCodeTips": "ဖိတ်ကြားကုဒ်ကို ထည့်သွင်းပါ",
    "account.inviteCodeHint": "ဖိတ်ကြားကုဒ်ရယူရန် တပ်ဆင်သူ သို့မဟုတ် ထိန်းသိမ်းရေးဝန်ထမ်းများကို ဆက်သွယ်ပါ",
  // 密码修改与恢复
  "account.modifyPasswordByAccount": "အကောင့်မှတစ်ဆင့် ပാസ်ဝေါဒ် ပြောင်းပါ",
  "account.modifyPasswordByEmail": "အီးမေးလ်ဖြင့် ပാസ်ဝေါဒ် ပြောင်းပါ",
  "account.getPasswordByAccount": "အကောင့်မှတစ်ဆင့် ပാസ်ဝေါဒ် ရယူပါ",
  "account.getPasswordByEmail": "အီးမေးလ်ဖြင့် ပാസ်ဝေါဒ် ရယူပါ",

  "account.sendEmailTips": "အတည်ပြုကုဒ်သည် အီးမေးလ်ထဲသို့ ပို့ပြီးပါပြီ, ကျေးဇူးပြု၍ စစ်ဆေးပါ",
  "account.name": "အကောင့် အမည်",
  "account.newPassword": "ပါတ်ဝေါဒ် အသစ်",
  "account.confirmNewPassword": "ပါတ်ဝေါဒ် အသစ် အတည်ပြုခြင်း",
  "account.nameTips": "အကောင့် အမည် ရိုက်ထည့်ပါ",
  "account.passwordModifySuccess": "ပാസ်ဝေါဒ် ပြောင်းခြင်း အောင်မြင်ပါသည်",
  "account.emailCode": "အီးမေးလ်အတည်ပြုကုဒ်",
  "account.emailCodeTips": "အီးမေးလ်အတည်ပြုကုဒ် ရိုက်ထည့်ပါ",
  "account.emailCodeTips2": "မမှန်ကန်သော အီးမေးလ်အတည်ပြုကုဒ်",
  "account.emailModifySuccess": "ပാസ်ဝေါဒ် ပြောင်းခြင်း အောင်မြင်ပါသည်",
  "account.passworTips1": "သင့် ပാസ်ဝေါဒ်ကို ပြန်လည် ထားပြီးပါပြီ!",
  "account.passwordTips11": "ပാസ်ဝေါဒ် အတည်ပြုရန် ရိုက်ထည့်ပါ",
  "account.passwordTips12": "ပါတ်ဝေါဒ် အသစ် ရိုက်ထည့်ပါ",
  "account.nickname": "အမှန်အမည် မဟုတ် အမည် (နစ်ကိုနိမ်း)",
  "account.modifyNickname": "နစ်ကိုနိမ်း ပြောင်းပါ",
  "account.modifyNicknameSuccess": "နစ်ကိုနိမ်း ပြောင်းခြင်း အောင်မြင်ပါသည်!",
  "account.nicknameTips": "နစ်ကိုနိမ်း ရိုက်ထည့်ပါ",
  "account.nicknameError": "နစ်ကိုနိမ်း ပြောင်းခြင်း မအောင်မြင်ပါဘူး!",

  // 快速注册与登录
  "account.login": "ဝင်ပါ",
  "account.quickRegister": "မြန်မြန် မှတ်ပုံတင်ခြင်း",
  "account.sendCode": "အတည်ပြုကုဒ် ပို့ပါ",
  "account.sendTips": "s စက္ကန့်အတွင်း ပြန်လည် ပို့နိုင်ပါသည်",
  "account.sendEmailIng": "အီးမေးလ် ပို့နေပါသည်... ကျေးဇူးပြု၍ စောင့်ပါ...",
  "account.emailNotEmpty": "အီးမေးလ် လိပ်စာ ကွက်လွတ် မရပါ",
  "account.registerAccount": "အကောင့် မှတ်ပုံတင်ခြင်း",
  "account.registerWelcome": "SusprSafe မှတ်ပုံတင်ခြင်းကို ကြိုဆိုပါတယ်",
  "account.usernameLimit": "အသုံးပြုသူ အမည်သည် အက္ခရာဖြင့် စတင်ရမည်၊ အက္ခရာများ၊ ကိန်းဂဏန်းများနှင့် အောက်ခြေလိုင်း (_) သာ ပါဝင်ရမည်၊ ရှည်လျားမှု 5-15 ဝေါဟာရ",

  // 版权信息
  "copyright.desc2": "ဝဘ်ဆိုက် မှတ်ပုံတင်ခြင်း အချက်အလက်: ကွမ်းဒေါင်းပြည်နယ် ICP မှတ်ပုံတင်ခြင်း နံပါတ် 2021169764",

  // 用户信息编辑
  "editUserInfo.editUserInformation": "အသုံးပြုသူ အချက်အလက် ပြောင်းပါ",
  "editUserInfo.modifyUsername": "အသုံးပြုသူ အမည် ပြောင်းပါ",
  "editUserInfo.changePictures": "ပရိုဖိုင်း ဓာတ်ပုံ ပြောင်းပါ",
  "editUserInfo.savePicturesSuccess": "ပရိုဖိုင်း ဓာတ်ပုံ သိမ်းဆည်းခြင်း အောင်မြင်ပါသည်",
  "editUserInfo.saveError": "သိမ်းဆည်းခြင်း မအောင်မြင်ပါဘူး",
  "editUserInfo.pictureLimit": "ဓာတ်ပုံ အရွယ်အစား 2 MB ထက် ကျော်မရပါ",
  "editUserInfo.uploadPicture": "ပရိုဖိုင်း ဓာတ်ပုံ ကိုယ်ယူပါ",
  "editUserInfo.picturePreview": "ကြိုကြည့်မှု",
  
  "editUserInfo.bindPhoneNumber": "ဖုန်းနံပါတ် ချိတ်ဆက်ပါ",
  "editUserInfo.bindEmail": "အီးမေးလ် ချိတ်ဆက်ပါ",
  "editUserInfo.changePassword": "ပാസ်ဝေါဒ် ပြောင်းပါ",

  "editUserInfo.notificationSettings": "အသိပေးချက် 设置",
  "editUserInfo.editAccount": "အကောင့် အချက်အလက် ပြောင်းပါ",
  "editUserInfo.waitBingting": "ချိတ်ဆက်နေပါသည်... ကျေးဇူးပြု၍ စောင့်ပါ...",
  "editUserInfo.collapse": "ကျုံ့ပါ (ပိုင်းခြားပါ)",
  "editUserInfo.modifyBinding": "ချိတ်ဆက်မှု ပြောင်းပါ",
  
  "editUserInfo.emailAddress": "အီးမေးလ် လိပ်စာ",
  "editUserInfo.tips1": "အီးမေးလ် ချိတ်ဆက်ခြင်း အောင်မြင်ပါသည်",
  "editUserInfo.tips2": "သိမ်းဆည်းခြင်း မအောင်မြင်ပါဘူး",
  "editUserInfo.tips3": "အီးမေးလ်အတည်ပြုကုဒ် ပို့နေပါသည်... ကျေးဇူးပြု၍ စောင့်ပါ...",
  "editUserInfo.tips4": "အတည်ပြုကုဒ်သည် xxxx အီးမေးလ်ထဲသို့ ပို့ပြီးပါပြီ, ကျေးဇူးပြု၍ စစ်ဆေးပါ",
  "editUserInfo.tips5": "အတည်ပြုကုဒ် ပို့ခြင်း မအောင်မြင်ပါဘူး!",
  "editUserInfo.tips6": "ဖုန်းနံပါတ်သည် כבר ချိတ်ဆက်ထားပါသည်",
  "editUserInfo.tips7": "အီးမေးလ်သည် כבר ချိတ်ဆက်ထားပါသည်",
  "editUserInfo.emailTips1": "အီးမေးလ် လိပ်စာ ရိုက်ထည့်ပါ",
  "editUserInfo.emailTips2": "မမှန်ကန်သော အီးမေးလ် ပုံစံ",
  "editUserInfo.emailTips3": "xxxx စက္ကန့်အတွင်း ပြန်လည် ပို့နိုင်ပါသည်",
  "editUserInfo.emailTips4": "အတည်ပြုကုဒ် ပို့ပါ",
  "editUserInfo.emailTips5": "အီးမေးလ်အတည်ပြုကုဒ် ကွက်လွတ် မရပါ",
  "editUserInfo.emailTips6": "မမှန်ကန်သော အီးမေးလ်အတည်ပြုကုဒ်",
  "editUserInfo.emailCode": "အီးမေးလ်အတည်ပြုကုဒ်",
  "editUserInfo.save": "သိမ်းဆည်းပါ",

  // 手机绑定相关
  "editUserInfo.phoneTips1": "ဖုန်းနံပါတ် ချိတ်ဆက်ခြင်း အောင်မြင်ပါသည်",
  "editUserInfo.phoneTips2": "SMSအတည်ပြုကုဒ် ပို့နေပါသည်... ကျေးဇူးပြု၍ စောင့်ပါ...",
  "editUserInfo.phoneTips3": "SMSအတည်ပြုကုဒ်သည် xxxx ဖုန်းနံပါတ်သို့ ပို့ပြီးပါပြီ, ကျေးဇူးပြု၍ စစ်ဆေးပါ",
  "editUserInfo.phoneTips4": "SMSအတည်ပြုကုဒ် ပို့ခြင်း မအောင်မြင်ပါဘူး!",
  "editUserInfo.phoneTips5": "ဖုန်းနံပါတ် ရိုက်ထည့်ပါ",
  "editUserInfo.phoneTips6": "မမှန်ကန်သော ဖုန်းနံပါတ် ပုံစံ",
  "editUserInfo.phoneTips7": "SMSအတည်ပြုကုဒ် ပို့ပါ",
  "editUserInfo.phoneTips8": "SMSအတည်ပြုကုဒ်",
  "editUserInfo.phoneTips9": "SMSအတည်ပြုကုဒ် ကွက်လွတ် မရပါ",
  "editUserInfo.phoneTips10": "မမှန်ကန်သော SMSအတည်ပြုကုဒ်",
  "editUserInfo.phone": "ဖုန်းနံပါတ်",


  // 通知设置
  "editUserInfo.noticeTips1": "အသိပေးချက် 设置 ရယူခြင်း မအောင်မြင်ပါဘူး!",
  "editUserInfo.noticeTips2": "အသိပေးချက် 设置 သိမ်းဆည်းခြင်း အောင်မြင်ပါသည်!",
  "editUserInfo.noticeTips3": "ဘက်ထရီ အဆင့် နိမ့်မှု အသိပေးချက်",
  "editUserInfo.noticeTips4": "ကားအားပေးစက် အားပေး ပြီးမှု အသိပေးချက်",
  "editUserInfo.errorNotification": "အမှား အသိပေးချက်",
  "editUserInfo.updateNotification": "အပ်ဒိတ် အသိပေးချက်",
  "editUserInfo.monthlyStatisticsNotification": "လစဉ် စာရင်းအင်း အသိပေးချက်",
  "editUserInfo.notificationMethod": "ရရှိမှု နည်းလမ်း",

  // 用户名相关提示
  "editUserInfo.userNameTips1": "အသုံးပြုသူ အမည် သိမ်းဆည်းခြင်း အောင်မြင်ပါသည်",
  "editUserInfo.userNameTips2": "အသုံးပြုသူ အမည် သိမ်းဆည်းခြင်း မအောင်မြင်ပါဘူး",
  "editUserInfo.userNameTips3": "အသုံးပြုသူ အမည် ရိုက်ထည့်ပါ",
  "editUserInfo.userNameTips4": "မမှန်ကန်သော အသုံးပြုသူ အမည် ပုံစံ: ကိန်းဂဏန်းများ၊ အောက်ခြေလိုင်း (_) နှင့် အင်္ဂလိပ် အက္ခရာများသာ ပါဝင်ရမည်",
  "editUserInfo.userNameTips5": "အသုံးပြုသူ အမည် ရိုက်ထည့်ပါ",
  "editUserInfo.userNameTips6": "သိမ်းဆည်းနေပါသည်... ကျေးဇူးပြု၍ စောင့်ပါ...",
  "editUserInfo.userName": "အသုံးပြုသူ အမည်",

  // 头像编辑提示
  "editUserInfo.avatorTips": "ပရိုဖိုင်း ဓာတ်ပုံ ပြောင်းရန် ကလစ်နှိပ်ပါ",
  "editUserInfo.verifyCodeTips1": "ရရှိထားသည့်အတည်ပြုကုဒ် ရိုက်ထည့်ပါ:",
  "editUserInfo.verifyCodeTips2": "သင့်အကောင့် လုံခြုံမှုအတွက်, မူရင်း ဖုန်းနံပါတ်သို့အတည်ပြုကုဒ် ပို့ရန် အောက်ပိုင်း ခလုတ်ကို ကလစ်နှိပ်ပါ:",
  "editUserInfo.verifyCodeTips3": "အတည်ပြုကုဒ် ပို့ပါ",
  "editUserInfo.verifyCodeTips4": "မူရင်း ဖုန်းနံပါတ်အတည်ပြုခြင်း အောင်မြင်ပါသည်, ချိတ်ဆက်ထားသည့် ဖုန်းနံပါတ် အသစ် ရိုက်ထည့်ပါ",
  "editUserInfo.verifyCodeTips5": "သင့်အကောင့် လုံခြုံမှုအတွက်, မူရင်း အီးမေးလ်သို့အတည်ပြုကုဒ် ပို့ရန် အောက်ပိုင်း ခလုတ်ကို ကလစ်နှိပ်ပါ:",
  "editUserInfo.verifyCodeTips6": "မူရင်း အီးမေးလ်အတည်ပြုခြင်း အောင်မြင်ပါသည်, အီးမေးလ် အသစ် ရိုက်ထည့်ပါ",
  "editUserInfo.verifyCodeTips7": "ပါတ်ဝေါဒ်ဟောင်း",
  "editUserInfo.verifyCodeTips8": "ပထမဦးစွာ အီးမေးလ် ချိတ်ဆက်ပါ!",
  "editUserInfo.verifyCodeTips9": "အတည်ပြုကုဒ်သည် အီးမေးလ်ထဲသို့ ပို့ပြီးပါပြီ, ကျေးဇူးပြု၍ စစ်ဆေးပါ",
  "editUserInfo.verifyCodeTips10": ", အလိုအလျောက် ဝင်ခွင့် စာမျက်နှာသို့ ပြန်ညွှန်းပါသည်",

  // 通知相关
  "hems.notice.title": "အသိပေးချက် ခေါင်းစဉ်", 
  "hems.notice.content": "အသိပေးချက် အကြောင်းအရာ", 
  "hems.notice.operate": "လုပ်ဆောင်ခြင်း",
  "hems.notice.noRead": "မဖတ်ရသေးပါ",
  "hems.notice.read": "ဖတ်ပြီးပါပြီ",
  "hems.notice.warning": "သတိပေးချက်",
  "hems.notice.error": "အမှား",
  "hems.notice.success": "စာရင်းအင်း တွက်ချက်ခြင်း",
  "hems.notice.sys": "စနစ် အချက်အလက်",
  "hems.notice.operateSuccess": "လုပ်ဆောင်ခြင်း အောင်မြင်ပါသည်",
  "hems.notice.operateTips": "လုပ်ဆောင်ရန် အရာအား ရွေးချယ်ပါ",

  // 首页
  "hems.home.selfuseRate": "ကိုယ်ပိုင် အသုံးပြုမှု ရာခိုင်နှုန်း",
  "hems.home.percent": "ရာခိုင်နှုန်း",
  "hems.home.todayData": "ယနေ့ဒေတာ",
  "hems.home.todayPowerGeneration": "ယနေ့ စွမ်းအင် မွေးထုတ်မှု",
  "hems.home.salesIncome": "စွမ်းအင် ရောင်းချမှု ဝင်ငွေ",
  "hems.home.saved": "သင် စုဆောင်းထားသည်",
  "hems.home.reduce": "ကာဗွန် လက္ခဏာ လျှော့ချပါ",
  "hems.home.tips1": "ဒေတာ ယခုအချိန်တွင် ရရှိနေပါဘူး, သင် xxxx ကို 아직 ချိတ်ဆက်မထားပါ",
  "hems.home.criticalLoad": "အရေးပေါ် ဝန်",
  "hems.home.keyVoltage": "အရေးပေါ် ဗို့တေ့",
  "hems.home.householdLoad": "အိမ် ဝန်",
  "hems.home.householdVoltage": "အိမ် ဗို့တေ့",
  "hems.home.generalLoad": "ယေဘုယျ ဝန်",
  "hems.home.generalVoltage": "ယေဘုယျ ဗို့တေ့",
  "hems.home.batteryHealth": "ဘက်ထရီ ကျန်းမာရေး အခြေအနေ",
  "hems.home.averageTemp": "ပျမ်းမျှ အပူချိန်",
  "hems.home.gridLoad": "လျှပ်စစ် ကွန်ရက် ဝန်",
  "hems.home.toggeleDataSource": "ပြသထားသည့်ဒေတာ ကို အောက်ပါအတိုင်း ပြောင်းပြီးပါပြီ:",
  "hems.home.toggleTips": "သင် ပြောင်းချင်ပါသလား?",
  "hems.home.modeSending": "မုဒ် ကမ်းမှတ် ပို့နေပါသည်... ကျေးဇူးပြု၍ စောင့်ပါ...",
  "hems.home.modeSuccess": "မုဒ် ပြောင်းခြင်း ကမ်းမှတ် ပို့ခြင်း အောင်မြင်ပါသည်!",
  "hems.home.isOnline": "အွန်းလိုင်း ရှိပါသလား?",
  "hems.home.useStatus": "အသုံးပြုမှု အခြေအနေ",
  "hems.home.workModeText": "လက်ရှိ အလုပ်မုဒ်:",
  "hems.home.toggleDataSourceText": "ပြသထားသည့်ဒေတာ ကို အောက်ပါအတိုင်း ပြောင်းပြီးပါပြီ:",
  "hems.ev.charge.status": "အားပေး အခြေအနေ",
  "hems.ev.charge.time": "အားပေး အချိန်",
  "hems.ev.charge.count": "အမှန်တကယ် အားပေး ပမာဏ (အချိန်နှင့်အတူ)",
  "hems.ev.charge.status.empty": "ကွက်လွတ်",
  "hems.ev.charge.status.ing": "ကေဘယ်နှင့် ချိတ်ဆက်ထား။ အားပေးနေပါသည်",
  "hems.ev.charge.status.null": "ကေဘယ်နှင့် ချိတ်ဆက်ထားပါသည်၊ သို့သော် အားပေးမရှိပါ",
  "hems.ev.charge.status.error": "အမှား",
  "hems.hour": "နာရီ",
  "hems.minue": "မိနစ်",
  "hems.ev.chagre.number": "ကားအားပေးစက် နံပါတ်",

  // 用户指南
  "hems.userGuide.selfUse": "မွေးထုတ်စွမ်းအင် ကိုယ်ပိုင် အသုံးပြုခြင်း",
  "hems.userGuide.selfUseTips": "ပထမဦးစွာ ဖိုတိုဗို့တေက် စွမ်းအင်ကို အသုံးပြုပါ၊ အလုံအလောက်မရှိပါက လျှပ်စစ်ကွန်ရက်ဖြင့် ဖြည့်ပါ",
  "hems.userGuide.economyMode": "စီးပွားရေး မုဒ်",
  "hems.userGuide.economyModeTips": "လျှပ်စစ် စွမ်းအင် ဈ่ายအမှုနှုန်းအရ စွမ်းအင် အသုံးပြုမှု ကုဒ်စည်းမျဉ်းကို အကောင်းဆုံး ပြုလုပ်ပါ",
  "hems.userGuide.emergencyMode": "အရေးပေါ် အခြေအနေ မုဒ်",
  "hems.userGuide.emergencyModeTips": "အရေးပေါ် ဝန်အတွက် စွမ်းအင် ထောက်ပံ့မှုကို ဦးစားပေးပါ",

  // 图表页面
  "hems.history.energyStatistics": "စွမ်းအင် စာရင်းအင်း",
  "hems.history.revenueStatistics": "ဝင်ငွေ စာရင်းအင်း",
  "hems.history.greenStatistics": "အစိမ်းရောင် ထုတ်လွှတ်မှု လျှော့ချမှု",
  "hems.history.revenueTitle": "စွမ်းအင် ရောင်းချမှု စုစုပေါင်း ဝင်ငွေ",
  "hems.history.savingsTitle": "စုဆောင်းမှု စုစုပေါင်း",
  "hems.history.carbonTitle": "ကာဗွန် လျှော့ချမှု စုစုပေါင်း",
  "hems.history.day": "နေ့",
  "hems.history.month": "လ",
  "hems.history.year": "နှစ်",
  "hems.history.beforeDay": "ယခင်နေ့",
  "hems.history.afterDay": "နောက်နေ့",
  "hems.history.beforeMonth": "ယခင်လ",
  "hems.history.afterMonth": "နောက်လ",
  "hems.history.beforeYear": "ယခင်နှစ်",
  "hems.history.afterYear": "နောက်နှစ်",
  "hems.history.totalUse": "စုစုပေါင်း အသုံးပြုမှု",
  "hems.history.fullScreen": "ဖুল်စက్రีน",
  "hems.history.timeSelect": "နေ့ရွေးပါ",
  "sync.tips1": "ဒေတာ သဟဇာတဖြစ်ခြင်း ကမ်းမှတ် ပို့ခြင်း အောင်မြင်ပါသည်!",
  "sync.tips2": "ဒေတာ သဟဇာတဖြစ်ခြင်း လုပ်ဆောင်နေပါသည်၊ ဒေတာ ပမာဏ ကြီးမားသောကြောင့် အချိန်လိုအပ်ပါသည်, ငါးဆယ်မိနစ်အတွင်း ပြန်လည် စစ်ဆေးပါ~",
  "sync.tips3": "ကိရိယာ ဒေတာ သဟဇာတဖြစ်ခြင်းတွင် နှောင့်နှေးမှု ရှိနိုင်ပါသည်, သင် ဒေတာများတွင် မတူညီမှုများကို တွေ့မြင်ပါက၊ အောက်ပိုင်း ကလုတ်ကို ကလစ်နှိပ်ပါ:",
  "sync.tips4": "ဒေတာ သဟဇာတဖြစ်ပါ",

  // 充电桩信息
  "charge.info": "ကားအားပေးစက် အချက်အလက်",
  "news.loading": "ကိုယ်ယူနေပါသည်...",
  "news.noMore": "ဒေတာ ထပ်မရှိပါ",
  "hems.pv.power": "ဖိုတိုဗို့တေက် စွမ်းအင် ပမာဏ",

  // UEH特定功能
  "ueh.sellPower": "ရောင်းချထားသည့် စွမ်းအင် ပမာဏ",
  
  // 菜单
  "menu.home": "ရှေ့စာမျက်နှာ",
  "menu.history": "သမိုင်းဒေတာ",
  "menu.device": "ကိရိယာများ",
  "menu.settings": "တည်ဆောက်သည်",
  "menu.messageCenter": "မက်ဆေ့ခ် ကင်တာ",
  "menu.help": "အကူအညီနှင့် ပံ့ပိုးပေးရေး",
  "menu.mine": "ကျွန်ုပ် (မိမိ)",


  // 我的设置
  "mine.userSetting": "အသုံးပြုသူ ဆက်တင်များ",
  "mine.terminalSetting": "Terminal ဆက်တင်များ",
  "mine.uploadCloud": "ဒေတာကို ကလောဒ်ထဲသို့ ကိုယ်ယူပါ",
  "mine.changeVersion": "အပ်ဒိတ် စစ်ဆေးပါ",
  "mine.language": "ဘာသာစကား ပြောင်းပါ",
  "mine.about": "အက်ပ್ಲီကေးရှင်းအကြောင်း",
  "mine.feedback": "ပြန်ကြားချက်",
  "mine.logout": "ထွက်ပါ",
  "mine.logoutAccount": "အကောင့် ဖျက်ပါ",

  // 注销账户相关
  "mine.logoutAccountTips": "[] အမည်ရှိ အကောင့် ဖျက်ပါ",
  "mine.logoutAccountTips1": "[] နှင့် ချိတ်ဆက်ထားသည့် အကောင့် ဖျက်ပါ",
  "mine.logoutAccountCare": "အကောင့် ဖျက်ခြင်း တောင်းဆိုမှု အကြောင်း မှတ်စု:",
  "mine.logoutAccountCare1": "1. အကောင့်သည် လုံခြုံသော အခြေအနေမျှ ဖြစ်သည်",
  "mine.logoutAccountCare1-1": "အကောင့်သည် ပုံမှန် အသုံးပြုမှု အခြေအနေမျှ ဖြစ်သည်, ခိုးယူမှု၊ စည်းမျဉ်းဖောက်ဖျက်မှု သို့မဟုတ် ပိတ်ဆို့မှု စွန့်စားမှု မရှိပါ",
  "mine.logoutAccountCare2": "2. အကောင့်၏ ခွင့်ပြုမှုများနှင့် ချိတ်ဆက်မှုများ ဖျက်ထားပါသည်",
  "mine.logoutAccountCare2-1": "တတိယပါတီ ပလက်ဖောင်းများအတွက် အကောင့်၏ ခွင့်ပြုမှုများအားလုံး ဖျက်ထားပါသည်",
  "mine.logoutAccountCare3": "3. ဖျက်ပြီးပါက အကောင့်ကို ပြန်လည် ရယူ၍မရပါ, အသုံးပြုသူ ဒေတာများ ဖျက်ထားပါသည်",
  "mine.logoutAccountCare3-1": "ဖျက်ပြီးပါက ချိတ်ဆက်ထားသည့် ဖုန်းနံပါတ်များ၊ အီးမေးလ်များနှင့် အခြား ဒေတာများ ဖျက်ထားပါသည်၊ ပြန်လည် ရယူ၍မရပါ",
  "mine.confirmLogout": "ဖျက်ခြင်း အတည်ပြုပါ",
  "mine.logoutSuccess": "အကောင့် ဖျက်ခြင်း အောင်မြင်ပါသည်!",


  // 反馈问题
  "mine.feedbackIssues": "ပြဿနာများနှင့် ပြန်ကြားချက်",
  "mine.feedQuantity": "ပမာဏ",
  "mine.feedAmount": "အများဆုံး 9 ဓာတ်ပုံ, ဓာတ်ပုံတစ်ခုစီ အကြီးဆုံး အရွယ်အစား 1 MB",

  // 通知设置相关
  "mine.notice.fail": "အသိပေးချက် 设置 ရယူခြင်း မအောင်မြင်ပါဘူး!",
  "mine.notice.saveSuccess": "အသိပေးချက် 设置 သိမ်းဆည်းခြင်း အောင်မြင်ပါသည်!",
  "mine.notice.saveFail": "သိမ်းဆည်းခြင်း မအောင်မြင်ပါဘူး!",
  "mine.notice.title": "အသိပေးချက် 设置",
  "mine.notice.batteryLow": "ဘက်ထရီ အဆင့် နိမ့်မှု အသိပေးချက်",
  "mine.notice.chargingFinish": "ကားအားပေးစက် အားပေး ပြီးမှု အသိပေးချက်",
  "mine.notice.error": "အမှား အသိပေးချက်",
  "mine.notice.update": "အပ်ဒိတ် အသိပေးချက်",
  "mine.notice.monthly": "လစဉ် စာရင်းအင်း အသိပေးချက်",
  "mine.notice.receiveType": "ရရှိမှု နည်းလမ်း",

  // 语言设置欢迎语
  "mine.language.welcome": "SusprSafe ကို ကြိုဆိုပါတယ်",
  "mine.language.desc1": "သင့်နေထိုင်မည့်နေရာနှင့်အညီ ဘာသာစကား ဗားရှင်းကို ရွေးချယ်ပါ",
  "mine.language.desc2": "သင်သည် အက်ပ್ಲီကေးရှင်း 设置တွင် မည်သည့်အချိန်တွင်မဆို ပြောင်းနိုင်ပါသည်",

  // 个人信息
  "mine.userInfo.avatar": "ပရိုဖိုင်း ဓာတ်ပုံ",
  "mine.userInfo.nickname": "နစ်ကိုနိမ်း",
  "mine.userInfo.password": "ပാസ်ဝေါဒ်",
  "mine.userInfo.changePassword": "ပാസ်ဝေါဒ် ပြောင်းပါ",
  "mine.userInfo.setPassword": "ပാസ်ဝေါဒ် ထားပါ",
  "mine.userInfo.phoneNumber": "ဖုန်းနံပါတ်",
  "mine.userInfo.bindPhone": "ဖုန်းနံပါတ် ချိတ်ဆက်ပါ",
  "mine.userInfo.bindEmail": "အီးမေးလ် ချိတ်ဆက်ပါ",
  "mine.loginExpired": "အကောင့် ဝင်ခွင့် ကာလကုန်ဆုံးပါသည်, ကျေးဇူးပြု၍ ပြန်လည် ဝင်ပါ",
  "mine.userInfo.title": "အသုံးပြုသူ အချက်အလက်",
  "mine.userInfo.bind": "ချိတ်ဆက်ပါ",
  "mine.userInfo.modify": "ပြောင်းပါ",
  "mine.userInfo.modifyNickname": "နစ်ကိုနိမ်း ပြောင်းပါ",
  "mine.userInfo.userNickname": "အသုံးပြုသူ နစ်ကိုနိမ်း",
  "mine.userInfo.selectPic": "ကိုယ်ယူရန် ဓာတ်ပုံကို ရွေးချယ်ပါ",
  "mine.userInfo.saveSuccess": "သိမ်းဆည်းခြင်း အောင်မြင်ပါသည်",
  "mine.userInfo.uploadFail": "ကိုယ်ယူခြင်း မအောင်မြင်ပါဘူး",
  "mine.userInfo.avatarSaveSuccess": "ပရိုဖိုင်း ဓာတ်ပုံ သိမ်းဆည်းခြင်း အောင်မြင်ပါသည်",
  "mine.userInfo.nameTips1": "နစ်ကိုနိမ်း ကွက်လွတ် မရပါ",
  "mine.userInfo.nameTips2": "နစ်ကိုနိမ်း ရိုက်ထည့်ပါ",

  // 通用选择提示
  "common.pleaseSelect": "ကျေးဇူးပြု၍ ရွေးချယ်ပါ",
  "question.commonQuestions": "မကြာခဏ မေးသောမေးခွန်းများ",
  "account.toggleLanguage": "ဘာသာစကား ပြောင်းပါ",
  "account.localConnection": "ဒေသဆိုင် ဆက်သွယ်မှု",
  "account.selectLanguage": "ကျေးဇူးပြု၍ ဘာသာစကား ရွေးချယ်ပါ",
  "account.sendEmailToast": "အတည်ပြုကုဒ်သည် xxx အီးမေးလ်ထဲသို့ ပို့ပြီးပါပြီ, ကျေးဇူးပြု၍ စစ်ဆေးပါ",
  "account.emailError": "မမှန်ကန်သော အီးမေးလ် ပုံစံ",
  "account.sendEmailFail": "ပို့ခြင်း မအောင်မြင်ပါဘူး, ကျေးဇူးပြု၍ ပြန်လည် ကြိုးစားပါ",
  
  "common.submitting": "ပို့နေပါသည်... ကျေးဇူးပြု၍ စောင့်ပါ...",

  "device.page.noData": "ဒေတာ ယခုအချိန်တွင် ရရှိနေပါဘူး, ဤစာမျက်နှာကို အက်ပ್ಲီကေးရှင်းအတွင်းသာ ကြည့်နိုင်ပါသည်"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};